import { config } from '../../config/config';

/**
 * The address of a file music24-api serves (`files/<uuid>/download`), or an address that is
 * already absolute, unchanged.
 *
 * The web app reaches music24-api on its own origin, under `/api_api/` (`config.fymApiURL(true)`,
 * the same base as every tRPC and REST call). The CSP allows that origin in img-src and
 * media-src. `fymApiURL(false)` is the FreeYourMusic server in production and staging, so a file
 * address built on it 404s and the CSP refuses it.
 *
 * The function is idempotent: an address that already starts with the base, with `/` or with a
 * scheme (`https:`, `http:`, `blob:`, `data:`) comes back unchanged. The Composer media keeps a
 * full address (`PromoteMediaDraft.fileUrl`), and the preview gave it the base a second time
 * (`/api_api//api_api/files/...`).
 */
export const getFullAPIFileURL = (path: string) => {
  const base = config.fymApiURL(true);
  if (path.startsWith(base) || path.startsWith('/') || /^(https?|blob|data):/.test(path)) {
    return path;
  }
  return `${base}${path}`;
};
